import { useEffect, useState } from 'react';
import { useAuth } from '../../../../scripts/fb';

export const UserAvatar = ({ handleMouseEnter }: { handleMouseEnter?: any }) => {
  const [name, setName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');

  const auth = useAuth();

  useEffect(() => {
    const user = auth?.user?.email;
    if (user) {
      const fullName = user.split(' ');
      setName(fullName[0].split('')[0].toUpperCase());
    }
  }, [auth?.user?.email]);

  return (
    <div className="User__profile-icon rounded-[5px] 2xl:mr-16 mr-10 cursor-pointer w-[32px] h-[30px]">
      <span
        className="text-white bold pt-0.5 text-base font-montserrat font-bold flex items-center justify-center"
        onMouseEnter={handleMouseEnter}>
        {name}
      </span>
    </div>
  );
};
